module.exports = __webpack_public_path__ + "static/media/tutorialCompra.1af00271.mp4";